export const beersList = [
    {
        name: 'Lager',
        price: 45.00,
    },
    {
        name: 'IPA',
        price: 52.00,
    },
    {
        name: 'Weissbier',
        price: 59.00,
    }
];